import { motion } from 'motion/react';
import { usePrefs } from './prefs';

export type MascotPose = 'jump' | 'wave' | 'trophy' | 'laugh' | 'peek';

const SRC: Record<MascotPose, { src: string; alt: string; ratio: number }> = {
  jump: { src: '/mascot.webp', alt: 'Pop, the party mascot, jumping for joy', ratio: 0.93 },
  wave: { src: '/mascot-wave.webp', alt: 'Pop waving hello', ratio: 1.01 },
  trophy: { src: '/mascot-trophy.webp', alt: 'Pop cheering with a trophy', ratio: 0.99 },
  laugh: { src: '/mascot-laugh.webp', alt: 'Pop laughing so hard it fell over', ratio: 0.98 },
  peek: { src: '/mascot-peek.webp', alt: 'Pop peeking around a corner with a wink', ratio: 1.08 },
};

/** Pop, the party mascot. Bounces gently unless the viewer prefers reduced motion. */
export function Mascot({ size = 160, pose = 'jump', className = '' }: { size?: number; pose?: MascotPose; className?: string }) {
  const { reducedMotion } = usePrefs();
  const img = SRC[pose];
  const src = pose === 'jump' && size <= 150 ? '/mascot-sm.webp' : img.src;
  return (
    <motion.img
      src={src}
      alt={img.alt}
      width={size}
      height={Math.round(size * img.ratio)}
      className={`select-none pointer-events-none drop-shadow-[0_10px_18px_rgba(0,0,0,0.45)] ${className}`}
      draggable={false}
      animate={reducedMotion ? undefined : pose === 'peek' ? { x: [0, -6, 0] } : { y: [0, -10, 0], rotate: [-2, 2, -2] }}
      transition={reducedMotion ? undefined : { duration: pose === 'peek' ? 3 : 2.4, repeat: Infinity, ease: 'easeInOut' }}
    />
  );
}
